export const UNAVAILABLE_SECTION_FILL = '#E6E8EC'
export const UNAVAILABLE_SECTION_LABEL = '#353945'
const DEFAULT_AVAILABLE_FILL = '#3E8BF7'

function seatIdsForRow(rowRef, rows) {
  if (rowRef && Array.isArray(rowRef.seats)) return rowRef.seats
  const row = rows?.[rowRef] ?? rows?.[String(rowRef)]
  return Array.isArray(row?.seats) ? row.seats : []
}

/** Physical seats in the section versus seats that currently have a ticket. */
export function countSectionAvailability(section, rows, seatLookupTable) {
  const rowRefs = Array.isArray(section?.rows) ? section.rows : []
  const lookup = seatLookupTable || {}
  let total = 0
  let available = 0

  for (const rowRef of rowRefs) {
    const seatIds = seatIdsForRow(rowRef, rows)
    total += seatIds.length
    for (const seatId of seatIds) {
      if (lookup[seatId]) available += 1
    }
  }

  return { total, available }
}

export function isSectionSoldOut(stats) {
  return (stats?.total ?? 0) > 0 && (stats?.available ?? 0) <= 0
}

export function sectionAvailabilityGradientId(sectionId) {
  return `sec-avail-${String(sectionId).replace(/[^a-zA-Z0-9_-]/g, '')}`
}

/**
 * Cover paint for a zoomable section.
 * A sold-out section is the unavailable gray. A partial section splits the
 * cover so the blue band matches the share of seats still for sale.
 * Sections with no seat geometry stay on the map fill — we can't tell.
 */
export function sectionOverlayPaint(section, stats) {
  const availableFill =
    section?.coverFill ?? section?.fill ?? DEFAULT_AVAILABLE_FILL
  const total = stats?.total ?? 0
  const available = stats?.available ?? 0

  if (isSectionSoldOut(stats)) {
    return {
      kind: 'solid',
      fill: UNAVAILABLE_SECTION_FILL,
      unavailableFill: UNAVAILABLE_SECTION_FILL,
      soldOut: true,
      labelFill: UNAVAILABLE_SECTION_LABEL,
      ratio: 0,
    }
  }

  if (total <= 0 || available >= total) {
    return {
      kind: 'solid',
      fill: availableFill,
      unavailableFill: UNAVAILABLE_SECTION_FILL,
      soldOut: false,
      labelFill: '#FFFFFF',
      ratio: 1,
    }
  }

  const ratio = available / total
  return {
    kind: 'gradient',
    fill: availableFill,
    unavailableFill: UNAVAILABLE_SECTION_FILL,
    soldOut: false,
    labelFill: ratio < 0.5 ? UNAVAILABLE_SECTION_LABEL : '#FFFFFF',
    ratio,
  }
}
